import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { V1SignInComponent } from './pages/v1-sign-in/v1-sign-in.component';
import { SignUpComponent } from './pages/sign-up/sign-up.component';

import { AuthenticationValidationService } from './modules/shared/services/authentication-validation.service';
import { LogoutComponent } from './pages/logout/logout.component';
import { ErrorComponent } from './pages/error/error.component';
import { NotificationMG1Component } from './modules/shared/components/notification-mg1/notification-mg1.component';
import { EditProfileComponent } from './modules/shared/components/edit-profile/edit-profile.component';
import { ShibbolethSignInComponent } from './pages/shibboleth-sign-in/shibboleth-sign-in.component';
import { SignInComponent } from './pages/sign-in/sign-in.component';
import { SupportComponent } from './pages/support/support.component';

export const routes: Routes = [
  {
    path: 'signin',
    pathMatch: 'full',
    component: SignInComponent
  },

  // {
  //   path: 'error',
  //   pathMatch: 'full',
  //   component: ErrorComponent
  // },
  {
    path: 'logout',
    pathMatch: 'full',
    // component: LogoutComponent
    component: SignInComponent

  },
  {
    path: 'signup',
    pathMatch: 'full',
    component: SignUpComponent,
    data: { title: '', breadCrumbs: '' }
  },
  {
    path: 'support',
    pathMatch: 'full',
    component: SupportComponent
  },
  {
    path: 'notifications',
    pathMatch: 'full',
    canActivate: [AuthenticationValidationService],
    component: NotificationMG1Component
  },
  {
    path: 'profile',
    pathMatch: 'full',
    canActivate: [AuthenticationValidationService],
    component: EditProfileComponent
  },
  {
    path: 'admin-dashboard',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/admin-dashboard/admin-dashboard.module').then(m => m.AdminDashboardModule),
    data: { headerHidden: true }
  },
  {
    path: 'bus-operators',
    loadChildren: () => import('./modules/bus-operators/bus-operators.module').then(m => m.BusOperatorsModule)
  },
  {
    path: 'buses',
    loadChildren: () => import('./modules/bus/bus.module').then(m => m.BusModule)
  },
  {
    path: 'bus-dashboard',
    loadChildren: () => import('./modules/bus-dashboard/bus-dashboard.module').then(m => m.BusDashboardModule),
    data: { headerHidden: true }
  },
  {
    path: 'bus-booking',
    loadChildren: () => import('./modules/bus-booking/bus-booking.module').then(m => m.BusBookingModule)
  },
  {
    path: 'cancellation-and-refunds',
    loadChildren: () => import('./modules/bus-manage-refunds/bus-manage-refunds.module').then(m => m.BusManageRefundsModule)
  },
  {
    path: 'additional-fares',
    loadChildren: () => import('./modules/bus-additional-fares/bus-additional-fares.module').then(m => m.BusAdditionalFaresModule)
  },
  {
    path: 'bus-routes',
    loadChildren: () => import('./modules/bus-routes/bus-routes.module').then(m => m.BusRoutesModule)
  },
  {
    path: 'bus-manage-schedule',
    loadChildren: () => import('./modules/bus-manage-schedule/bus-manage-schedule.module').then(m => m.BusManageScheduleModule)
  },
  {
    path: 'bus-drivers',
    loadChildren: () => import('./modules/bus-drivers/bus-drivers.module').then(m => m.BusDriversModule)
  },
  {
    path: 'bus-seat-layouts',
    loadChildren: () => import('./modules/bus-seat-layouts/bus-seat-layouts.module').then(m => m.BusSeatLayoutsModule)
  },
  {
    path: 'bus-manage-tours',
    loadChildren: () => import('./modules/bus-manage-tour/bus-manage-tour.module').then(m => m.BusManageTourModule)
  },
  {
    path: 'manage-contents',
    loadChildren: () => import('./modules/bus-manage-content/bus-manage-content.module').then(m => m.BusManageContentModule)
  },
  {
    path: 'manage-taxes',
    loadChildren: () => import('./modules/bus-taxes/bus-taxes.module').then(m => m.BusTaxesModule)
  },
  {
    path: 'manage-fare-passes',
    loadChildren: () => import('./modules/bus-day-pass/bus-day-pass.module').then(m => m.BusDayPassModule)
  },
  {
    path: 'drivers',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/drivers/drivers.module').then(m => m.DriversModule)
    },
  {
    path: 'reports',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/reports/reports.module').then(m => m.ReportsModule)

  },
  {
    path: 'settings',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/settings/settings.module').then(m => m.SettingsModule)

  },
  {
    path: 'passengers',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/passengers/passengers.module').then(m => m.PassengersModule)

  },
  {
    path: 'user-management',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/user-management/user-management.module').then(m => m.UserManagementModule)

  },
  {
    path: 'marketing',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/marketing/marketing.module').then(m => m.MarketingModule)
  },
  {
    path: 'admin-chat',
    loadChildren: () => import('./modules/admin-chat/admin-chat.module').then(m => m.AdminChatModule)
  },
  {
    path: 'customer-feedbacks',
    loadChildren: () => import('./modules/customer-feedback/customer-feedback.module').then(m => m.CustomerFeedbackModule)
  },
  {
    path: 'support-management',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/support-management/support-management.module').then(m => m.SupportManagementModule)
  },
  {
    path: 'app-release-history',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/app-release-history/app-release-history.module').then(m => m.AppReleaseHistoryModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: true })
  ],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule { }
